import React, { forwardRef, HtmlHTMLAttributes, memo } from "react";
import classNames from "classnames";

import { ReactComponent as DotCircleImage } from "./image/dot-circle.svg";
import { ReactComponent as LineSimpleImage } from "./image/line-simple.svg";
import { ReactComponent as LineSpinnerImage } from "./image/line-spinner.svg";

import styles from "./style.module.scss";

export type LoadingIndicatorType = "dotCircle" | "lineSpinner" | "lineSimple";
export type LoadingIndicatorSize = "sm" | "md" | "lg" | "xl";

export type LoadingIndicatorProps = HtmlHTMLAttributes<HTMLDivElement> & {
  loadingIndicatorSize?: LoadingIndicatorSize;
  loadingIndicatorLabel?: string;
  loadingIndicatorType?: LoadingIndicatorType;
  labelClassName?: string;
  spinnerClassName?: string
};

export const LoadingIndicator = memo(forwardRef<HTMLDivElement, LoadingIndicatorProps>((
  {
    loadingIndicatorSize = "xl",
    loadingIndicatorLabel = "Loading...",
    loadingIndicatorType = "dotCircle",
    className,
    labelClassName,
    spinnerClassName,
    ...props
  },
  ref) => {

  const getSpinnerType = () => {
    switch (loadingIndicatorType) {
      case "dotCircle":
        return <DotCircleImage />;
      case "lineSpinner":
        return <LineSpinnerImage />;
      case "lineSimple":
        return <LineSimpleImage />;
      default:
        return <DotCircleImage />;
    }
  };

  return (
    <div
      className={classNames(
        styles.root,
        styles[loadingIndicatorSize as keyof typeof styles],
        className,
      )}
      {...props}
      ref={ref}
    >
      <div
        className={classNames(
          styles.spinner,
          styles[loadingIndicatorSize as keyof typeof styles],
          spinnerClassName,
        )}
      >
        {getSpinnerType()}
      </div>
      {loadingIndicatorLabel && (
        <p className={classNames(styles.label, labelClassName)}>{loadingIndicatorLabel}</p>
      )}
    </div>
  );
}));
